<template>
	<div class="AcronymsBox">
		<div class="ModalWindow">
<!--			<div class="CloseButton" @click="closeUpdate"></div>-->
      <div v-html="closeIcon" v-on:click="closeUpdate" class="closeIcon" ></div>
		</div>

		<div id="AcronymsHeader">
			<h2>Acronyms List</h2>
			<span>Definitions of the acronyms used within this app are found here.</span>
		</div>

		<div id="AcronymsList">
			<div>
        <span class="ItemTitle">AESQ13004</span>
        <span>Aerospace standard for the creation and use of FMEAs and Control Plans.</span>
      </div>
			<div style="margin-bottom: 15px;">
        <span class="ItemTitle">Benchmark Assessment Tool</span>
        <span>A collaborative tool for determining whether the basic controls are adequate for a manufacturing process.</span>
      </div>
			<div>
        <span class="ItemTitle">CI</span>
        <span>Continuous Improvement – ongoing, incremental activities to improve manufacturing processes and products.</span>
      </div>
			<div>
        <span class="ItemTitle">CMM</span>
        <span>Co-ordinate Measuring Machine - A device that measures the geometry of physical objects by sensing discrete points on the surface of the object with a probe.</span>
      </div>
			<div>
        <span class="ItemTitle">Control Plan </span>
        <span>A document that describes the process control requirements to maintain product quality.</span></div>
			<div>
        <span class="ItemTitle">C P</span>
        <span>Chemical Processing – manufacturing processes that use chemicals to clean or otherwise process components.</span></div>
			<div>
        <span class="ItemTitle">EBW</span>
        <span>Electron Beam Welding – welding through the use of an electron beam to melt the material.</span>
      </div>
			<div>
        <span class="ItemTitle">Escape</span>
        <span>The failure to detect non-conformance in a product.</span></div>
			<div>
        <span class="ItemTitle">FMEA</span>
        <span>Failure Modes and Effects Analysis - A structured methodology for understanding potential failure modes for a product.</span></div>
			<div>
        <span class="ItemTitle">FPA</span>
        <span>Fixed Process Approval – process for ensuring any changes to a manufacturing process are properly controlled and approved.  Similar to MVA (Method Verification Approval).</span></div>
			<div>
        <span class="ItemTitle">Go-Look-See</span>
        <span>Observing the manufacturing process on the shop floor.</span></div>
			<div>
        <span class="ItemTitle">KPV</span>
        <span>Key Process Variable – An input variable to a manufacturing process that has a significant effect on the process output.</span></div>
			<div>
        <span class="ItemTitle">NC</span>
        <span> Numerical Control - The automated control of machining tools by means of a computer.</span></div>
			<div>
        <span class="ItemTitle">NDE</span>
        <span>Non-Destructive Evaluation – a group of inspection techniques, including penetrant inspection, x ray inspection and ultrasonic inspection, used to evaluate the properties of material.</span></div>
			<div>
        <span class="ItemTitle">NPI</span>
        <span>New Product Introduction - Process of releasing product in a way to have the most beneficial outcome.</span></div>
			<div>
        <span class="ItemTitle">PFMEA</span>
        <span>Process Failure Modes and Effects Analysis - A structured methodology for understanding potential process failures that can affect product quality.</span></div>
			<div>
        <span class="ItemTitle">REACH</span>
        <span>European Union regulation concerning chemicals</span></div>
			<div>
        <span class="ItemTitle">RFT</span>
        <span>Right First Time - A measure of the number of parts completed without re-work, scrap or concession.</span></div>
			<div>
        <span class="ItemTitle">SCU</span>
        <span>Supply Chain Unit - Organisational unit within a business based on the product family that is designed and/or manufactured.</span></div>
			<div>
        <span class="ItemTitle">Siemens NX</span>
        <span>CAD/CAM software package.</span></div>
			<div>
        <span class="ItemTitle">SPMA</span><span>Special Process Maturity Assessment – another name for the benchmark assessment tool when applied to special processes.</span></div>
			<div>
        <span class="ItemTitle">TIG</span><span>Tungsten Inert Gas – welding through the use of an electric arc generated from a tungsten electrode, also known as Gas Metal Arc Welding (GMAW).</span></div>
				</div>
	</div>
</template>

<script>
import iconService from "@/services/iconService";
	export default {
		name: "AcronymsModal",

		data () {
			return {
        closeIcon: iconService.icons.CloseSmall
      }
		},

		methods: {
			closeUpdate () {
				this.$emit('acronymsState', false)
				this.$emit('close')
			}
		},
	}
</script>
<style scoped>
  .closeIcon{
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }
</style>